import styled from "styled-components";
import { CheckboxButton } from "./CheckboxButton";
import { Text } from "../typography/Texts";

import { T } from "../i18n/Translation";
import { AcceptanceCheckbox } from "src/contexts/documentationArea/domain/AcceptanceCheckbox";
import { useTheme } from "src/apps/providers/ThemeStore";
import { colors } from "@permisso/permisso-components";
import { TEST_IDS } from "src/apps/config/testIds";

type CheckboxesProps = {
  acceptanceCheckboxes: AcceptanceCheckbox[] | undefined;
  checkboxesStatus: boolean[];
  setAllCheckboxStatus: (value: boolean[]) => void;
  className?: string;
};

export const AcceptanceCheckboxes = ({
  acceptanceCheckboxes,
  checkboxesStatus,
  setAllCheckboxStatus,
  className,
}: CheckboxesProps) => {
  const { companyName } = useTheme();
  const onChangeCheckbox = (i: number) => {
    const newArray = [...checkboxesStatus];
    newArray[i] = !newArray[i];
    setAllCheckboxStatus(newArray);
  };

  if (!acceptanceCheckboxes) return null;

  return (
    <AcceptanceCheckboxWrapper className={className} data-testid={TEST_IDS.consents.container}>
      {acceptanceCheckboxes.map((checkbox, i) => {
        return (
          <CheckBoxWrapper key={i} data-testid={TEST_IDS.consents.item(i)}>
            <ButtonWrapper>
              <CheckboxButton
                dataTestId={TEST_IDS.consents.checkbox}
                onClick={() => onChangeCheckbox(i)}
                checked={checkboxesStatus[i]}
              />
            </ButtonWrapper>
            <CheckboxText $color={colors.grey700}>
              <T k={checkbox.text} params={{ companyName }} />
            </CheckboxText>
          </CheckBoxWrapper>
        );
      })}
    </AcceptanceCheckboxWrapper>
  );
};

const ButtonWrapper = styled.div`
  padding: 0.125rem;
`;

const AcceptanceCheckboxWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.5rem;
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

const CheckboxText = styled(Text)``;
